export const MicrosoftLogo = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.75882 1.5H1.21741V9.04141H8.75882V1.5Z" fill="#F25022" />
      <path d="M17.2201 1.5H9.67871V9.04141H17.2201V1.5Z" fill="#7FBA00" />
      <path
        d="M8.75882 9.95898H1.21741V17.5004H8.75882V9.95898Z"
        fill="#00A4EF"
      />
      <path
        d="M17.2201 9.95898H9.67871V17.5004H17.2201V9.95898Z"
        fill="#FFB900"
      />
    </svg>
  );
};
